{
  "sessionExpired": "Votre session a expiré - veuillez vous reconnecter",
  "codeVerified": "Votre code a été vérifié",
  "passwordChanged": "Votre mot de passe a été modifié",
  "accountCreated": "Votre compte a été créé",
  "accountDeleted": "Votre compte a été supprimé",
  "unableToDeleteAccount": "Nous n'avons pas pu supprimer votre compte, veuillez réessayer",
  "bookingDetailsUpdated": "Détails de la réservation mis à jour",
  "addStopError": "Impossible d'ajouter l'arrêt",
  "editStopError": "Impossible de modifier l'arrêt",
  "removeStopError": "Impossible de supprimer l'arrêt",
  "locationError": "Impossible de récupérer la position",
  "defaultAddressError": "Impossible de récupérer l'adresse par défaut",
  "delayError": "Impossible de récupérer le délai de réservation",
  "unableToCompletePayment": "Nous n'avons pas pu finaliser votre paiement, veuillez réessayer",
  "unableToProceedBooking": "Nous n'avons pas pu poursuivre cette réservation, veuillez réessayer",
  "unableToAddCard": "Nous n'avons pas pu ajouter votre carte, veuillez réessayer",
  "unableToDeleteCard": "Nous n'avons pas pu supprimer votre carte, veuillez réessayer",
  "unableToDefaultCard": "Nous n'avons pas pu définir votre carte par défaut, veuillez réessayer",
  "profileUpdated": "Votre profil a été mis à jour",
  "editProfileError": "Impossible de modifier le profil",
  "cardAdded": "Votre carte a été ajoutée",
  "cardDeleted": "Votre carte a été supprimée",
  "cardDefaulted": "Votre carte par défaut a été mise à jour",
  "unableToCancelBooking": "Nous n'avons pas pu annuler cette réservation",
  "unableToEditBooking": "Nous n'avons pas pu modifier cette réservation",
  "unableToCopyBooking": "Nous n'avons pas pu copier cette réservation",
  "favouriteAdded": "Favori ajouté",
  "favouriteCleared": "Favori supprimé",
  "favouriteEdited": "Favori modifié",
  "unableToAddFavourite": "Nous n'avons pas pu ajouter ce favori",
  "unableToClearFavourite": "Nous n'avons pas pu supprimer ce favori",
  "unableToEditFavourite": "Nous n'avons pas pu modifier ce favori",
  "unableToFindBookingTemplate": "Impossible de trouver le modèle de réservation",
  "unableToSearchForAddresses": "Impossible de rechercher des adresses",
  "unableToSearchForContacts": "Impossible de rechercher des contacts",
  "unableToSearchForReports": "Impossible de rechercher des rapports",
  "unableToLoadJourneyDetails": "Impossible de charger les détails du trajet",
  "secretKeyCopied": "Clé secrète copiée",
  "contactLink": {
    "contactLinkRequestSent": "Demande de lien de contact envoyée",
    "contactLinkRequestFailed": "La demande de lien de contact a échoué",
    "unableToLoadLinkedContacts": "Impossible de charger les contacts liés",
    "contactLinkAuthorised": "Lien de contact autorisé",
    "contactLinkRejected": "Lien de contact refusé"
  },
  "jobDetailsCopied": "Détails de la course copiés dans le presse-papiers",
  "unableToSignOn": "Impossible de finaliser la connexion",
  "vouchers": {
    "voucherRemoved": "Bon {voucherCode} supprimé",
    "unableToAddVoucher": "Impossible d'ajouter le bon",
    "voucherAdded": "Bon {voucherCode} ajouté",
    "voucherAlreadyAdded": "Le bon {voucherCode} a déjà été ajouté"
  },
  "unableToOpenFile": "Impossible d'ouvrir {file}",
  "missingFormData": "Données du formulaire manquantes",
  "missingLeadPassengerDetails": "Détails du passager principal manquants",
  "quickQuoteUnavailable": "Devis rapide indisponible",
  "reporting": {
    "export": {
      "copyMessage": "Rapport copié",
      "error": "Erreur d'exportation"
    }
  },
  "deviceIntegrityWarning": "Cet appareil semble avoir été modifié, ce qui pourrait mettre vos données en danger",
  "newNotification": "Nouvelle notification"
}
